import React from "react";
import { Typewriter } from "react-simple-typewriter";

const Blog = () => {
  return (
    <div className="h-screen flex justify-center items-center">
      <h1 className="font-semibold text-4xl text-indigo-400">
        <span style={{ color: "#5C6BC5" }}>
          {/* Style will be inherited from the parent element */}
          <Typewriter
            words={["Coming Soon...."]}
            loop={false}
            cursor
            cursorStyle="_"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
          />
        </span>
      </h1>
    </div>
  );
};

export default Blog;
